import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Table, Image, Row, Col, Modal, Form } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import { TextField, InputLabel, FormControl, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { AllVendorTableHead } from "../superAdminVendorTable/firstPageTable/AllVendorTableHead";
import { AuthorizedUserProfilePage } from "../superAdminVendorTable/ProfilePageViewReusable/AuthorizedUserProfilePage";
import SlidingComponent from "../../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import SuperAdminFlag from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminFlag";
import SuperAdminBlockUser from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminBlockUser";
import SuperAdminNotification from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminNotification";
import SuperAdminSMS from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
import SuperAdminCall from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import { BusinessHoursMultiplePopup } from "../../../superAdminReusable/reusablePopupSuperAdmin/BusinessHoursMultiplePopup";
import { SuperAdminVendorViewDetailsPopup } from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminVendorViewDetailsPopup";

import { get_vendor_single_rating_review } from "../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";

import isEmpty from "../../../../../store/validation/is-Empty";
import { getVendorOptedSubscriptionServices } from "../../../../reusableComponents/reusableFunctionsSubscription";
import {
  ORDER_STATUS,
  ORDER_TYPE,
  PAYMENT_STATUS,
  PAYMENT_TYPE,
} from "../../../../../enums/OrderEnums";
import { PaymentActivity } from "../../../../vendorDashboardComponents/PaymentActivityReports/PaymentActivityReports";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { PaymentActivityAdminReportVendor } from "../../../../../store/actions/VendorReports/vendorReportsRestaurant";
import { SmallLoader } from "../../../../Loader/SmallLoader";

const VendorRatingReviewProfile = (props) => {
  let dispatch = useDispatch();
  let history = useHistory();
  const [showAdd, setShowAdd] = useState(false);
  const [pic, setPic] = useState(null);
  const handleChangeCode = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  const uploadImage = (e) => {
    setPic(URL.createObjectURL(e.target.files[0]));
  };
  const handleCloseAdd = () => setShowAdd(false);
  const handleShowAdd = () => setShowAdd(true);

  // const ratingReviewAction = (e) => {
  //   history.push("/superadminvendorsratingview");
  // };

  const ratingReviewAction = (data) => (e) => {
    dispatch(get_vendor_single_rating_review(data, onReviewSuccess(data)));
  };

  const onReviewSuccess = (data) => (e) => {
    history.push({
      pathname: "/superadminvendorsratingview",
      state: { data: data },
    });
  };

  const location = useLocation();
  const [vendorInfo, setVendorInfo] = useState({});

  useEffect(() => {
    if (vendorInfo?.vendor_id && props?.auth?.user?.accessToken) {
      props.PaymentActivityAdminReportVendor(
        props?.auth?.user?.accessToken,
        vendorInfo?.vendor_id,
        "0"
      );
      props.PaymentActivityAdminReportVendor(
        props?.auth?.user?.accessToken,
        vendorInfo?.vendor_id,
        "1"
      );
      props.PaymentActivityAdminReportVendor(
        props?.auth?.user?.accessToken,
        vendorInfo?.vendor_id,
        "2"
      );
    }
  }, [vendorInfo?.vendor_id, props?.auth?.user?.accessToken]);

  useEffect(() => {
    setVendorInfo(location?.state?.data);
  }, [location]);

  const [state, setState] = useState({
    code: "",
    country: "",
    state: "",
    role: "",
    monday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 10),
        closing_time: new Date(2020, 1, 1, 12),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 16),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 19),
        closing_time: new Date(2020, 1, 1, 22),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 10),
          closing_time: new Date(2020, 1, 1, 12),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 16),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 19),
          closing_time: new Date(2020, 1, 1, 22),
          description: "Dinner",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 24),
          closing_time: new Date(2020, 1, 1, 4),
          description: "Midnight Munching",
        },
      ],
    },
    tuesday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    wednesday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    thursday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    friday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    saturday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    sunday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
  });

  let filteredData = {};
  filteredData =
    vendorInfo.point_of_contact &&
    vendorInfo.point_of_contact.filter(
      (vendor) => vendor.defaultChecked === true
    );

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation
              backIcon={true}
              link={"/superadminallvendors"}
              displayText={"Back"}
            />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Vendor Profile</div>
                <Button
                  variant="danger"
                  className=" btn2 btn-lg"
                  onClick={handleShowAdd}
                >
                  + Add Restaurant User
                </Button>
              </div>
              <div className="enShadowBox p-0 w-100">
                <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                  <Table>
                    <thead>
                      <AllVendorTableHead />
                    </thead>
                    <tbody className="w-100 super-admin-all-vendor-main-table-body">
                      <tr className="w-100 p-0">
                        <td className="p-0 w-100">
                          <table className="w-100">
                            <tbody className="sd_body_css">
                              <tr className="sd_body_table-row">
                                <td style={{ width: "15%" }}>
                                  <div className="vendor-main-section-one">
                                    <div className="image-box">
                                      <div className="Image-box-section">
                                        <Image
                                          fluid
                                          alt="wait time"
                                          title="wait time"
                                          src={vendorInfo.logo_url}
                                        />
                                        <div className="inside-image-box-discout">
                                          <Image
                                            fluid
                                            alt="Discount Picture"
                                            title="Discount Picture"
                                            src={require("../../../../../assets/images/superadmin/discount.svg")}
                                          />
                                        </div>
                                      </div>
                                      <div>
                                        <h5 className="font_16_m mt-2">
                                          #{vendorInfo.vendor_id}
                                        </h5>
                                      </div>
                                    </div>
                                    <div className="start-rating-review-box mt-2">
                                      <Image
                                        fluid
                                        alt="wait time"
                                        title="wait time"
                                        className="star-image-box mr-1"
                                        src={require("../../../../../assets/images/superadmin/star.svg")}
                                      />
                                      <h5 className="font_16_m d-flex align-items-center">
                                        {vendorInfo.averageRating}{" "}
                                        <div className="font_10_r ml-1">
                                          ({vendorInfo.totalReviews})
                                        </div>
                                      </h5>
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "14%" }}>
                                  <h3 className="font_20_m">
                                    {vendorInfo.restaurant_name}
                                  </h3>
                                </td>
                                <td style={{ width: "16%" }}>
                                  {!isEmpty(filteredData) &&
                                    filteredData.map((singleitem, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <div className="font_18_m d-flex">
                                            {singleitem.firstName +
                                              " " +
                                              singleitem.lastName}
                                          </div>
                                          {!isEmpty(
                                            singleitem.enquiry_emails
                                          ) &&
                                            singleitem.enquiry_emails.map(
                                              (email, index) => {
                                                return (
                                                  <React.Fragment key={index}>
                                                    <div className="font_18_m mb-2 mt-2 text-lowercase">
                                                      {email}
                                                    </div>
                                                  </React.Fragment>
                                                );
                                              }
                                            )}
                                          {!isEmpty(singleitem.phone_numbers) &&
                                            singleitem.phone_numbers.map(
                                              (phone, index) => {
                                                return (
                                                  <React.Fragment key={index}>
                                                    <div className="font_18_m">
                                                      {phone.country_code +
                                                        " " +
                                                        phone.mobile_no}
                                                    </div>
                                                  </React.Fragment>
                                                );
                                              }
                                            )}
                                        </React.Fragment>
                                      );
                                    })}
                                </td>
                                <td style={{ width: "21%" }}>
                                  <div className="font_18_r">
                                    {vendorInfo.restaurant_address}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="font_18_m">
                                    {vendorInfo?.primary_restaurant_type &&
                                      vendorInfo?.primary_restaurant_type[0]
                                        .title}
                                  </div>
                                  <div className="font_18_r">
                                    {vendorInfo?.primary_cusine &&
                                      vendorInfo?.primary_cusine[0].title}
                                  </div>
                                  <div className="w-75">
                                    <hr />
                                    <div className="font_18_r d-flex align-items-center">
                                      <img
                                        className=" mr-2"
                                        height="20px"
                                        src={
                                          vendorInfo?.primary_food_type &&
                                          vendorInfo?.primary_food_type[0].icon
                                        }
                                      />
                                      {vendorInfo?.primary_food_type &&
                                        vendorInfo?.primary_food_type[0].title}
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "7%" }}>
                                  {/* {!isEmpty(vendorInfo.vendor) &&
                                    vendorInfo.vendor.map((value, index) => {
                                      return (
                                        <React.Fragment key={index}> */}
                                  <SlidingComponent
                                    name="has_admin_approved"
                                    currentState={
                                      vendorInfo &&
                                      vendorInfo?.vendor &&
                                      vendorInfo?.vendor?.has_admin_approved
                                    }
                                    type={"checkbox"}
                                    toggleclass={
                                      "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                                    }
                                    toggleinputclass={
                                      "toggle__switch vendor-super-admin-toggle"
                                    }
                                    onChange={props.toggleFunction}
                                    // slidingonClick={this.onSelecttogglestatusChange(data)}
                                    defaultChecked={
                                      vendorInfo &&
                                      vendorInfo?.vendor &&
                                      vendorInfo?.vendor?.has_admin_approved
                                    }
                                  />
                                  {/* </React.Fragment>
                                      );
                                    })} */}
                                </td>
                                <td style={{ width: "12%" }}>
                                  <div
                                    className="pt-3 pb-3 f10-700 text-center"
                                    style={{
                                      border: "1px solid #EE3A23",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    View Dashboard
                                  </div>
                                  {/* <div className="d-flex align-items-center justify-content-end mb-2">
                                    <Button
                                      variant="link"
                                      className="enIconBtn action_icon_padding"
                                      onClick={props.handleShowEdit}
                                    >
                                      <Image
                                        src={require("../../../../../assets/images/ActionImages/image/onboarding.svg")}
                                        alt="View"
                                        title="View"
                                        fluid
                                      />
                                    </Button>
                                    <Button
                                      variant="link"
                                      className="enIconBtn ml-2 action_icon_padding"
                                      onClick={ratingReviewAction(vendorInfo)}
                                    >
                                      <Image
                                        src={require("../../../../../assets/images/ActionImages/image/rating.svg")}
                                        alt="Rating"
                                        title="Rating"
                                        fluid
                                      />
                                    </Button>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-end">
                                    <Button
                                      variant="link"
                                      className="enIconBtn action_icon_padding"
                                      onClick={props.handleShowEdit}
                                    >
                                      <Image
                                        src={require("../../../../../assets/images/ActionImages/image/order.svg")}
                                        alt="View"
                                        title="View"
                                        fluid
                                      />
                                    </Button>
                                    <NavLink to="/superadmineventmanagement">
                                      <Button
                                        variant="link"
                                        className="enIconBtn ml-2 action_icon_padding"
                                        onClick={props.handleShowEdit}
                                      >
                                        <Image
                                          src={require("../../../../../assets/images/ActionImages/image/events.svg")}
                                          alt="View"
                                          title="View"
                                          fluid
                                        />
                                      </Button>
                                    </NavLink>
                                  </div> */}
                                </td>
                              </tr>
                              <tr className="sd_accordion_body">
                                <td style={{ width: "20%" }}>
                                  <h5 className="font_18_b mb-3">
                                    Staff Management
                                  </h5>
                                  <Button
                                    variant="link"
                                    className="enIconBtn mr-3"
                                    onClick={props.handleShowFlag}
                                  >
                                    <Image
                                      src={require("../../../../../assets/images/UserManagement/staff.svg")}
                                      alt="View"
                                      title="View"
                                      fluid
                                    />
                                  </Button>
                                </td>
                                <td style={{ width: "20%" }}>
                                  <h5 className="font_18_b mb-3">Payouts</h5>
                                  <Button
                                    variant="link"
                                    className="enIconBtn mr-3"
                                    onClick={props.handleShowFlag}
                                  >
                                    <Image
                                      src={require("../../../../../assets/images/UserManagement/Receipt.svg")}
                                      alt="View"
                                      title="View"
                                      fluid
                                    />
                                  </Button>
                                </td>
                              </tr>
                              <tr className="sd_accordion_body">
                                <td style={{ width: "26%" }}>
                                  <h5 className="font_18_b mb-3">Contact</h5>
                                  <div className="d-flex align-items-center">
                                    <SuperAdminCall />
                                    <Button
                                      variant="link"
                                      className="enIconBtn mr-3"
                                      onClick={props.handleShowFlag}
                                    >
                                      <Image
                                        src={require("../../../../../assets/images/UserManagement/forum.svg")}
                                        alt="View"
                                        title="View"
                                        fluid
                                      />
                                    </Button>
                                    <SuperAdminSMS data={vendorInfo} />
                                    <SuperAdminNotification />
                                  </div>
                                </td>
                                <td style={{ width: "17%" }}>
                                  <div className="font_18_b mb-4">
                                    {" "}
                                    No. of Seating Request
                                  </div>
                                  <h5 className="font_18_r">
                                    {vendorInfo.No_seating_request}
                                  </h5>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="font_18_b mb-4">
                                    No. of Orders
                                  </div>
                                  <h5 className="font_18_r">
                                    {vendorInfo.No_ordering_request}
                                  </h5>
                                </td>
                                <td style={{ width: "13%" }}>
                                  <div className="font_18_b mb-4">
                                    No. of Offers
                                  </div>
                                  <h5 className="font_18_r">
                                    {vendorInfo.No_offers}
                                  </h5>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="font_18_b mb-4">
                                    No. of Events
                                  </div>
                                  <h5 className="font_18_r">
                                    {vendorInfo.No_events}
                                  </h5>
                                </td>
                                <td style={{ width: "24%" }}>
                                  <h5 className="font_18_b c_red mb-3">
                                    More Actions
                                  </h5>
                                  <div className="d-flex align-items-center">
                                    <SuperAdminFlag
                                      data={vendorInfo}
                                      actionCall="active"
                                    />
                                    <SuperAdminBlockUser
                                      data={vendorInfo}
                                      actionCall="active"
                                    />
                                    {/* <SuperAdminVendorViewDetailsPopup
                                      viewData={vendorInfo}
                                    /> */}
                                    <Button
                                      variant="link"
                                      className="enIconBtn mr-3 action_icon_padding"
                                    >
                                      <Image
                                        src={require("../../../../../assets/images/UserManagement/eye.svg")}
                                        alt="View"
                                        title="View"
                                        fluid
                                      />
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                              <tr className="sd_accordion_body">
                                <td style={{ width: "15%" }}>
                                  <div className="font_18_b mb-4">Revenue</div>
                                  <h5 className="font_18_r">
                                    {vendorInfo.revenue}
                                  </h5>
                                </td>
                                <td style={{ width: "17%" }}>
                                  <BusinessHoursMultiplePopup
                                    monday={state.monday.multipleHours}
                                    tuesday={state.tuesday.multipleHours}
                                    wednesday={state.wednesday.multipleHours}
                                    thursday={state.thursday.multipleHours}
                                    friday={state.friday.multipleHours}
                                    saturday={state.saturday.multipleHours}
                                    sunday={state.sunday.multipleHours}
                                  />
                                  <h5 className="font_18_r">
                                    Closes: {moment().format("HH : mm A")}
                                  </h5>
                                  <div className="mt-2 font_18_r d-flex align-items-center">
                                    <Image
                                      src={require("../../../../../assets/images/UserManagement/clock.svg")}
                                      alt="View"
                                      title="View"
                                      fluid
                                      width="16px"
                                      className="mr-2"
                                    />
                                    {vendorInfo.seatingWaitingTime}
                                    <span className="text-red ml-2">
                                      {vendorInfo.seatingWaitingTime === "00-00"
                                        ? ""
                                        : "Wait"}
                                    </span>
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="font_18_b mb-4">Address</div>
                                  <h5 className="font_18_r">
                                    {vendorInfo.area}, {vendorInfo.city},{" "}
                                    {vendorInfo.pinCode}
                                  </h5>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="font_18_b mb-4">
                                    POS System
                                  </div>
                                  <h5 className="font_18_r">-</h5>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="font_18_b mb-4">
                                    Services Offered
                                  </div>
                                  {vendorInfo?.primary_services_offered
                                    ?.length &&
                                    vendorInfo?.primary_services_offered.map(
                                      (service, i) => (
                                        <h5
                                          className="font_18_r"
                                          style={{ padding: "0px 2px" }}
                                          key={i}
                                        >
                                          {service.title}
                                        </h5>
                                      )
                                    )}
                                  {/* <div className="font_18_b mb-4">
                                    Member Since
                                  </div>
                                  <h5 className="font_18_r">
                                    {moment(vendorInfo.createdAt).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </h5> */}
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="font_18_b mb-4">
                                    Located Inside
                                  </div>
                                  {vendorInfo?.selected_located_inside
                                    ?.length &&
                                    vendorInfo.selected_located_inside.map(
                                      (service) => (
                                        <h5
                                          className="font_18_r"
                                          style={{ padding: "0px 2px" }}
                                        >
                                          {service.title}
                                        </h5>
                                      )
                                    )}
                                </td>
                                <td style={{ width: "13%" }}>
                                  <div className="font_18_b mb-4">Liquor</div>
                                  {vendorInfo?.selected_liquor_category?.length
                                    ? vendorInfo.selected_liquor_category.map(
                                        (service, i) => (
                                          <h5
                                            className="font_18_r"
                                            style={{ padding: "0px 2px" }}
                                            key={i}
                                          >
                                            {service.title}
                                          </h5>
                                        )
                                      )
                                    : ""}
                                </td>
                                {/* <td style={{ width: "24%" }}></td> */}
                              </tr>
                              <tr className="sd_accordion_body">
                                <td style={{ width: "15%" }}>
                                  <div className="font_18_b mb-4">Cuisines</div>
                                  <div className="d-flex align-items-center">
                                    {vendorInfo?.primary_cusine?.length &&
                                      vendorInfo?.primary_cusine?.map(
                                        (cusine, i) => (
                                          <h5
                                            className="font_18_r"
                                            style={{ padding: "0px 2px" }}
                                            key={i}
                                          >
                                            {cusine.title}
                                          </h5>
                                        )
                                      )}
                                  </div>
                                </td>
                                <td style={{ width: "17%" }}>
                                  <div className="font_18_b mb-4">
                                    Subscription
                                  </div>
                                  <h5 className="font_18_r text-break">
                                    {getVendorOptedSubscriptionServices(
                                      vendorInfo?.casual_dining,
                                      vendorInfo?.fast_food_dining,
                                      vendorInfo?.multi_service_business
                                    )}
                                  </h5>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="font_18_b mb-4">
                                    Member Since
                                  </div>
                                  <h5 className="font_18_r">
                                    {moment(vendorInfo.createdAt).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </h5>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="font_18_b mb-4">
                                    3rd Party Delivery <br />
                                    Partners
                                  </div>
                                  <h5 className="font_18_r">-</h5>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="font_18_b mb-4">
                                    Menu Setup <br />
                                    Subscription type
                                  </div>
                                  <h5 className="font_18_r">Premium</h5>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="font_18_b mb-4">
                                    Printer Integration
                                  </div>
                                  <h5 className="font_18_r">No</h5>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <div className="p-4 d-flex justify-content-between align-items-center">
                  <div className="font_16_b">Authorized Users</div>
                  <NavLink to="/" variant="link" className="text-blue f10-500">
                    View All
                  </NavLink>
                </div>
                {!isEmpty(vendorInfo.point_of_contact) &&
                  vendorInfo.point_of_contact.map((singleitem, index) => {
                    return (
                      <React.Fragment key={index}>
                        <AuthorizedUserProfilePage userData={singleitem} />
                      </React.Fragment>
                    );
                  })}
                <PaymentActivity
                  PaymentActivityOrderReport={() => {}}
                  PaymentActivityEventReport={() => {}}
                  PaymentActivityScanReport={() => {}}
                  auth={props?.auth}
                  admin
                  paymentOrder={props?.paymentOrder || []}
                  paymentEvent={props?.paymentEvent || []}
                  paymentScan={props?.paymentScan || []}
                />
                {/* <div className="p-4 d-flex justify-content-between align-items-center">
                  <div className="font_16_b">Payment Transactions</div>
                  <NavLink to="/" variant="link" className="text-blue f10-500">
                    View All
                  </NavLink>
                </div>
                <div className="col-12 p-0  user-table-reusable-superadmin table-responsive">
                  <Table>
                    <thead>
                      <TableHead />
                    </thead>
                    <TableBody
                      paymentOrder={tempdata}
                      auth={props.auth}
                      start={start}
                      end={end}
                      handleView={handleView}
                    />
                  </Table>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showAdd} onHide={handleCloseAdd} centered size="lg">
        <Modal.Header className="border-0 pl-4" closeButton>
          <Modal.Title className="f24_500_HelveticaNeue">
            Add Authorized User
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 f16-500">
          <Form>
            <Row>
              <Col md={12}>
                <div className="enUploadEditPic">
                  <div className="user-profile-image w-100 h-100">
                    <Image
                      fluid
                      className="w-100 h-100"
                      src={
                        pic
                          ? pic
                          : require("../../../../../assets/images/ActionImages/demoprofile.jpg")
                      }
                    />
                  </div>
                  <div className="enUploadIcon">
                    <input
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => uploadImage(e)}
                    />
                    <Image
                      src={require("../../../../../assets/images/UserManagement/picUpload.svg")}
                      alt="chairs"
                      title="chairs"
                      className="w-100 h-100"
                    />
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    label="Name"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    type="email"
                    label="Email Address"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    type="password"
                    label="password"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    type="password"
                    label="Confirm password"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Row>
                  <Col xs={4} className="pr-0">
                    <FormControl variant="outlined" className="w-100">
                      <Select
                        value={state.code}
                        onChange={handleChangeCode}
                        inputProps={{
                          name: "code",
                        }}
                      >
                        <option value={+91}>+91</option>
                      </Select>
                    </FormControl>
                  </Col>
                  <Col xs={8}>
                    <Form.Group>
                      <TextField
                        id="outlined-basic"
                        label="Phone Number"
                        variant="outlined"
                        className="w-100"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-role">Role</InputLabel>
                    <Select
                      value={state.role}
                      onChange={handleChangeCode}
                      label="Role"
                      inputProps={{
                        name: "role",
                        id: "outlined-role",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="role">Role</option>
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-country">country</InputLabel>
                    <Select
                      value={state.country}
                      onChange={handleChangeCode}
                      label="Country"
                      inputProps={{
                        name: "country",
                        id: "outlined-country",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="country">Country</option>
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-state">State</InputLabel>
                    <Select
                      value={state.state}
                      onChange={handleChangeCode}
                      label="state"
                      inputProps={{
                        name: "state",
                        id: "outlined-state",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="state">State</option>
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    label="City"
                    type="text"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex align-items-center pt-5">
              <Button
                variant="outline-secondary"
                className="mr-4 px-5 py-2"
                onClick={handleCloseAdd}
              >
                Cancel
              </Button>
              <Button variant="danger" className="px-5  py-2" type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

VendorRatingReviewProfile.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  paymentOrder: PropTypes.array.isRequired,
  paymentEvent: PropTypes.array.isRequired,
  paymentScan: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  paymentOrder: state?.reports?.payment_order?.data || [],
  paymentEvent: state?.reports?.payment_event?.data || [],
  paymentScan: state?.reports?.payment_scan?.data || [],
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  PaymentActivityAdminReportVendor,
})(VendorRatingReviewProfile);

// export default VendorRatingReviewProfile;

function TableHead() {
  return (
    <tr>
      <th style={{ width: "150px" }}>Transaction ID</th>
      <th style={{ width: "150px" }}>User Name</th>
      <th style={{ width: "150px" }}>
        Payment <br />
        Method
      </th>
      <th style={{ width: "150px" }}>Transaction Type</th>
      <th style={{ width: "150px" }}>Date & Time</th>
      <th style={{ width: "150px" }}>Sub Total</th>
      <th style={{ width: "150px" }}>Tip</th>
      <th style={{ width: "150px" }}>Donation</th>
      <th style={{ width: "150px" }}>Sub Total</th>
      <th style={{ width: "150px" }}>Tip</th>
      <th style={{ width: "150px" }}>Donation</th>
      <th style={{ width: "150px" }}>
        Bag & <br />
        Packing Fee
      </th>
      <th style={{ width: "150px" }}>
        Convenience <br />
        Fee
      </th>
      <th style={{ width: "150px" }}>GST</th>
      <th style={{ width: "150px" }}>Total Amount</th>
      <th style={{ width: "150px" }}>Payment Status</th>
      <th style={{ width: "150px" }}>Action</th>
    </tr>
  );
}

const TableBody = (props) => {
  const data = props?.data;
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              {props?.auth?.secondary_loader ? (
                <SmallLoader />
              ) : (
                !isEmpty(props?.paymentOrder) &&
                props?.paymentOrder
                  .slice(props?.start, props?.end)
                  .map((item, index) => {
                    return (
                      <tr
                        className="sd_body_table-row"
                        // style={{ textAlign: "center" }}
                        key={index}
                      >
                        {/* {console.log(item.amount)} */}
                        <td style={{ width: "12%" }}>
                          <div className="f12-500">
                            {ORDER_TYPE[item?.orderId?.order_type]}
                            <br />
                            {item?.orderId?.order_id}
                          </div>
                        </td>
                        <td style={{ width: "12%" }}>
                          <div className="f12-500">
                            {item?.transactionNumber || item?._id}
                          </div>
                        </td>
                        <td style={{ width: "12%" }} className="text-center">
                          <div className="d-flex align-items-center">
                            <div className="super-admin-suggestion-imageBoxTwo ml-2">
                              <div className="f12-500">
                                {item?.user_id?.first_name}
                                {item?.user_id?.last_name}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={{ width: "15%" }}>
                          <div className="f12-500">
                            {PAYMENT_TYPE[item?.orderId?.payment_method]}
                          </div>
                          {item?.orderId?.payment_status === 0 ? (
                            <div
                              className="badge badge-warning p-2"
                              style={{ borderRadius: "1rem", color: "white" }}
                            >
                              {PAYMENT_STATUS[item?.orderId?.payment_status]}
                            </div>
                          ) : null}
                          {item?.orderId?.payment_status === 1 ? (
                            <div
                              className="badge badge-success p-2"
                              style={{ borderRadius: "1rem", color: "white" }}
                            >
                              {PAYMENT_STATUS[item?.orderId?.payment_status]}
                            </div>
                          ) : null}
                          {item?.orderId?.payment_status === 2 ? (
                            <div
                              className="badge badge-danger p-2"
                              style={{ borderRadius: "1rem", color: "white" }}
                            >
                              {PAYMENT_STATUS[item?.orderId?.payment_status]}
                            </div>
                          ) : null}
                          {item?.orderId?.payment_status === 3 ? (
                            <div
                              className="badge badge-danger p-2"
                              style={{ borderRadius: "1rem", color: "white" }}
                            >
                              {PAYMENT_STATUS[item?.orderId?.payment_status]}
                            </div>
                          ) : null}
                          {item?.orderId?.payment_status === 4 ? (
                            <div
                              className="badge badge-info p-2"
                              style={{ borderRadius: "1rem", color: "white" }}
                            >
                              {PAYMENT_STATUS[item?.orderId?.payment_status]}
                            </div>
                          ) : null}
                        </td>

                        <td style={{ width: "10%" }}>
                          <div className="f12-500">
                            {item?.orderId.order_items.length}
                          </div>
                        </td>

                        <td style={{ width: "10%" }}>
                          <div className="f12-500">
                            {ORDER_STATUS[item?.orderId?.order_status]}
                          </div>
                        </td>
                        <td style={{ width: "10%" }}>
                          <div className="f12-400">
                            {moment(item?.createdAt).format("Do MMM YYYY")}
                          </div>
                          <div className="f12-400">
                            {moment(item?.createdAt).format("hh:mm A")}
                          </div>
                        </td>
                        <td style={{ width: "10%" }}>
                          <div className="f12-500">₹ {item?.amount}</div>
                        </td>
                        <td style={{ width: "6%" }}>
                          <div
                            className="f10-400 m-2"
                            align="center"
                            // onClick={() => handleView(item?.orderId)}
                          >
                            <img
                              src={require("../../../../../assets/images/iconButton/eye.png")}
                              width="35px"
                              alt="icon"
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
